export enum eTypeSetting {
  Recepcion = 1,
  ReglasRutaPicking = 2,
  ValidacionRutaPicking = 3,
  CourierEtiquetas = 4,
  Automatizaciones = 5,
  General = 6
}